
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';

import { config } from '../config';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-comment-history',
  templateUrl: './comment-history.component.html',
  styleUrls: ['./comment-history.component.css']
})
export class CommentHistoryComponent implements OnInit {

  requestedQuotesList: any = [];
  config: any = config;
  environment: any = environment;
  actionUrl: any;
  
  userDetails: any = {};
  loading: boolean = false;
  quoteLength: any = 10;

  isClaimIntimated:boolean=false;
  intimationNumber:string;
  error:string;
  claimsStatus: any = [];
  claimUnderProcess: any=[];
  intimatedDate:any;

  product:any;

  Claim_Intimated = 'Claim Intimated';
  Acknowledged = 'Acknowledged by Insurer';
  IntialDocumentSubmitted = 'Initial Document Submitted';
  ClaimUnderProcess = 'Claim Under Process';
  paid = 'Paid';
  intimationNo: any;
  claimInfo:any;
  registeredDate:any

  AcknowledgedByinsurer:any;
  isAcknowledgedByinsurer:boolean;

  getdocument:any = [];
  isgetdocument:boolean;
  finalStatus:boolean;
  getamounts:string;
  isgetamounts:boolean;
  dateByinsurer:any;
  finalStatusName:string;

  isoutstanding:boolean;

  documentsdDate:any;

  documentsdDate1:any;

  outstandingSubStatus:any = [];

  getdocumentss:any = [];

  acknowledgedByinsurers: any = []

  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService, private router1: ActivatedRoute, ) { }

  ngOnInit() {
    this.finalStatusName = 'Paid'
    this.actionUrl = this.environment.pam2Url + this.config.returningUserQuote;
 
    this.intimationNo = this.router1.snapshot.params['id'];
    this.getClaimInfoByIntimation();

    this.getClaimDetailByIntimationNo();
    this.getByInsurer();
    this.getdocuments();
    this.getamount();    
  }

  //claim history status

  getClaimInfoByIntimation(){
    // this.intimationNo='SNGHI2021RHICRU451 ';
    this.serviceURLService.getClaimHistoryByIntimations(this.intimationNo).subscribe((success: any) => {
      this.claimsStatus = success.response.pamResponse.data[0];
      this.intimatedDate = this.claimsStatus[0].lastUpdated;
 
      if(this.claimsStatus[0].claimsStatus=='Claim Intimated'){
        this.isClaimIntimated=true;

      }

      if(this.claimsStatus[1].claimsStatus=='Acknowledged'){
        this.isAcknowledgedByinsurer = true
      }

      else if(this.claimsStatus[1].claimsStatus=='Document Saved'){
        this.isgetdocument = true
        this.isAcknowledgedByinsurer = true
      }

      else if(this.claimsStatus[1].claimsStatus=='OUTSTANDING'){
        this.claimUnderProcess = success.response.pamResponse.data[1];
        this.isoutstanding=true;
        this.isgetdocument = true
        this.isAcknowledgedByinsurer = true
 
          for(let i=0; i<this.claimUnderProcess.length; i++){
              this.outstandingSubStatus.push(this.claimUnderProcess[i].claimStage)
              
          }
        }

        else if(this.claimsStatus[1].claimsStatus=='PAID'){
          this.isoutstanding=true;
          this.isgetdocument = true
          this.isAcknowledgedByinsurer = true
          this.finalStatus = true
          this.finalStatusName = 'Paid'

          this.outstandingSubStatus.push('Under registration with insurer')
          this.outstandingSubStatus.push('Under Medical Scrutiny(Fresh Claim)')
          this.outstandingSubStatus.push('Under Medical Scrutiny(After query reply)')
          this.outstandingSubStatus.push('Under Audit')
          this.outstandingSubStatus.push('Under Investigation/Survey')
          this.outstandingSubStatus.push('Under Query')
          this.outstandingSubStatus.push('Reopening approval requested from insurer')
          this.outstandingSubStatus.push('Referred to Insurer for Delay intimation/submission approval')
          this.outstandingSubStatus.push('Claim approved/Ready for Payment')
          this.outstandingSubStatus.push('Deficient')
        }

        else if(this.claimsStatus[1].claimsStatus=='Rejected/Repudiated'){
          this.isoutstanding=true;
          this.isgetdocument = true
          this.isAcknowledgedByinsurer = true
          this.finalStatus = true
          this.finalStatusName = 'Rejected/Repudiated'

          this.outstandingSubStatus.push('Under registration with insurer')
          this.outstandingSubStatus.push('Under Medical Scrutiny(Fresh Claim)')
          this.outstandingSubStatus.push('Under Medical Scrutiny(After query reply)')    
          this.outstandingSubStatus.push('Under Audit')
          this.outstandingSubStatus.push('Under Investigation/Survey')
          this.outstandingSubStatus.push('Under Query')
          this.outstandingSubStatus.push('Reopening approval requested from insurer')
          this.outstandingSubStatus.push('Referred to Insurer for Delay intimation/submission approval')
          this.outstandingSubStatus.push('Claim approved/Ready for Payment')
          this.outstandingSubStatus.push('Deficient')
        }

        else if(this.claimsStatus[1].claimsStatus=='CLOSED'){
          this.isoutstanding=true;
          this.isgetdocument = true
          this.isAcknowledgedByinsurer = true
          this.finalStatus = true
          this.finalStatusName = 'closed'

          this.outstandingSubStatus.push('Under registration with insurer')
          this.outstandingSubStatus.push('Under Medical Scrutiny(Fresh Claim)')
          this.outstandingSubStatus.push('Under Medical Scrutiny(After query reply)')
          this.outstandingSubStatus.push('Under Audit')
          this.outstandingSubStatus.push('Under Investigation/Survey')
          this.outstandingSubStatus.push('Under Query')
          this.outstandingSubStatus.push('Reopening approval requested from insurer')
          this.outstandingSubStatus.push('Referred to Insurer for Delay intimation/submission approval')
          this.outstandingSubStatus.push('Claim approved/Ready for Payment')
          this.outstandingSubStatus.push('Deficient')
        } 

    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }

  

  getByInsurer(){

    this.serviceURLService.getnoByInsurer(this.intimationNo).subscribe((success: any) => {
      this.AcknowledgedByinsurer = success.response.pamResponse.data.claimNumber;
      this.dateByinsurer = success.response.pamResponse.timeStamp;
       
      if((this.AcknowledgedByinsurer == "NA" || this.AcknowledgedByinsurer == null) || this.AcknowledgedByinsurer == "null"){
       this.isAcknowledgedByinsurer = false;
      }

      else{
        this.isAcknowledgedByinsurer = true;
      }


    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }

  getdocuments(){
    // this.intimationNumber='SNGHI2021SNTSTG263';
    this.serviceURLService.getdocuments(this.intimationNo).subscribe((success: any) => {
      this.getdocument = success.response.pamResponse.data;
      this.documentsdDate = success.response.pamResponse.timeStamp;

       var obj = JSON.parse(JSON.stringify(this.getdocument))


       for (const key in obj){
        let documentobj = {name:'', count:''}
         documentobj.name=key
         documentobj.count=obj[key]
         this.getdocumentss.push(documentobj);
       }

       if((this.getdocument == "NA" || this.getdocument == null) || this.getdocument == "null"){
        this.isgetdocument = false;
       }
 
       else{
        
         if(this.isAcknowledgedByinsurer){
          this.isgetdocument = true;
         }
         else{
          this.isgetdocument = false;
         }
       }


    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }


  getamount(){
    // this.intimationNumber='SNGHI2021SNTSTG263';
    this.serviceURLService. getgetamount(this.intimationNo).subscribe((success: any) => {
      this.getamounts = success.data;

      if((this.getamounts == "NA" || this.getamounts == null) || this.getamounts == "null"){
        this.isgetamounts = false;
       }

       else{
        
        if(this.isAcknowledgedByinsurer){
         this.isgetamounts = true;
        }
        else{
         this.isgetamounts = false;
        }

      
      }
      

    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }


  getClaimDetailByIntimationNo() {
  
    this.serviceURLService.getClaimInfoByIntimationNo(this.intimationNo).subscribe((successData: any) => {
      this.loading = false;
        this.claimInfo = successData.response.pamResponse.data;
        this.registeredDate = this.claimInfo[0].dateCreated;
        console.log(" inprogress register date " + this.registeredDate);
        

    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }

}
